import { useEffect, useState } from 'react'
import { AuthModal } from '@/components/auth/modals/AuthModal'

interface ResetParams {
  token: string
  id: string
  username: string
  app: string
}

const PasswordReset = () => {
  const [modalOpened, setModalOpened] = useState(false)
  const [resetParams, setResetParams] = useState<ResetParams | null>(null)

  useEffect(() => {
    // Check URL for reset parameters
    const url = new URL(window.location.href)
    const token = url.searchParams.get('token')
    const id = url.searchParams.get('id')
    const username = url.searchParams.get('username')
    const app = url.searchParams.get('app')

    if (token && id && username && app) {
      setResetParams({ token, id, username, app })
      setModalOpened(true)
    }
  }, [])

  const handleModalClose = () => {
    // Clear URL params when closing the modal
    window.history.replaceState({}, document.title, window.location.pathname)
    setModalOpened(false)
    setResetParams(null)
  }

  return resetParams ? <AuthModal opened={modalOpened} onClose={handleModalClose} initialStep="create_new_password" resetParams={resetParams} /> : null
}

export default PasswordReset
